<app-header *ngIf="showDefaultHeader"></app-header>
<app-header-1 *ngIf="showHeader1"></app-header-1>

<main>
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>

    